import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppConfigModel } from '../models/appmodel';

@Injectable()
export class AppConfigService {
  private appConfig = new AppConfigModel();

  constructor() {}

  // Load configuration file
  loadAppConfig() {
    const ISSUER = `${environment.appConfig.issuer}`;
    const CLIENT_ID = `${environment.appConfig.clientId}`;
    const RESPONSE_TYPE = `${environment.appConfig.responseType}`;
    const SCOPE = `${environment.appConfig.scope}`;
    const CLIENT_SECRET = `${environment.appConfig.clientSecret}`;
    const REDIRECT_URI = `${environment.appConfig.redirectUri}`;
    const LOGOUT_URL = `${environment.appConfig.logoutUrl}`;

    this.appConfig.issuer = ISSUER;
    this.appConfig.clientId = CLIENT_ID;
    this.appConfig.responseType = RESPONSE_TYPE;
    this.appConfig.scope = SCOPE;
    this.appConfig.clientSecret = CLIENT_SECRET;
    this.appConfig.redirectUri = REDIRECT_URI;
    this.appConfig.logoutUrl = LOGOUT_URL;
  }

  // get the configuration
  get config() {
    return this.appConfig;
  }
}
